<template>
  <v-footer v-bind="$attrs" :style="footerStyle">
    <slot />
  </v-footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useLayout } from "vuetify";

defineOptions({ inheritAttrs: false });

const { mainStyles } = useLayout();

/**
 * v-main is padded by `--v-layout-left` so a fixed nav drawer does not cover
 * page content. The footer is outside v-main, so copy that inset or the
 * drawer paints over the footer's left edge.
 */
const footerStyle = computed(() => ({
  ...mainStyles.value,
  marginLeft: "var(--v-layout-left, 0px)",
  marginRight: "var(--v-layout-right, 0px)",
}));
</script>
